import type { UnknownAction } from 'redux';

import { reportStoreTypes, reportUpserters } from '../core';
import * as actions from './accountsBalancesHistoryActions';
import type { AccountsBalancesHistoryStore } from './accountsBalancesHistoryTypes';

const initialState = reportStoreTypes.mkReportStore({}) as AccountsBalancesHistoryStore;

const reducer = (
  state: AccountsBalancesHistoryStore = initialState,
  action: UnknownAction,
): AccountsBalancesHistoryStore => {
  switch (true) {
    case actions.getAccountsBalancesHistory.match(action):
      return state.set('isLoading', true);

    case actions.getAccountsBalancesHistorySuccess.match(action):
      return reportUpserters.upsertReports(state, action.payload);

    case actions.getAccountsBalancesHistoryFailure.match(action):
      return state.merge({ error: action.payload, isLoading: false });

    default:
      return state;
  }
};

export default reducer;
